import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { STATE_IDENTIFIER } from "./constants";

const {
  STEP_ONE,
  CONFIGURE_TABLES,
  SELECTED_TYPE,
  DATA_IDENTIFIER,
  LOADER_IDENTIFIER,
  CALL_STATE,
} = STATE_IDENTIFIER;

export default {
  [CALL_STATE]: IResponseState.PENDING,
  [STEP_ONE]: {
    [SELECTED_TYPE]: "",
  },
  [CONFIGURE_TABLES]: {
    [LOADER_IDENTIFIER]: false,
    [DATA_IDENTIFIER]: {},
  },
};
